/*
 * Pipeline Theme — Vege Threads customizations
 * Loaded via layout/theme.liquid.
 */

(function () {
  // Product grid card image arrows.
  // Works with the <product-grid-item-variant> custom element defined in theme.js.
  // Arrows cycle images manually alongside hover-to-second-image behavior,
  // and ensure the target <template>-wrapped image is promoted to DOM.
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-card-arrow]') : null;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    var host = btn.closest('product-grid-item-variant');
    if (!host) return;

    var images = host.querySelectorAll('[data-grid-image]');
    var total = images.length;
    if (total < 2) return;

    var direction = btn.getAttribute('data-card-arrow');
    var currentIndex = 0;
    for (var i = 0; i < total; i++) {
      if (images[i].hasAttribute('data-grid-current-image')) {
        currentIndex = i;
        break;
      }
    }

    var nextIndex = direction === 'next'
      ? (currentIndex + 1) % total
      : (currentIndex - 1 + total) % total;

    if (typeof host.preloadImages === 'function') host.preloadImages();
    if (typeof host.changeImage === 'function') {
      host.changeImage(nextIndex);
    } else {
      for (var j = 0; j < total; j++) images[j].removeAttribute('data-grid-current-image');
      images[nextIndex].setAttribute('data-grid-current-image', 'true');
    }

    host.pagingProgressPause = true;
    if (typeof host.stopPaging === 'function') host.stopPaging();
  });
})();
